/* eslint-disable no-magic-numbers */
import { videoMaxBytes } from "widgets/social2/utils";

export const MAX_LENGTH_LANDING_PAGE = 800;
export const MAX_VIDEO_BYTES = videoMaxBytes();
export const MIN_VIDEO_SEC = 1;
export const MAX_VIDEO_MIN = 15;
export const VIDEO_ACCEPT = ".mp4, .mov";
